import * as React from "react"
import { cn } from "../../lib/utils"

const Table = React.forwardRef((props, ref) => (
  <div className="relative w-full overflow-auto">
    <table
      ref={ref}
      className={cn("w-full caption-bottom text-sm", props.className)}
      {...props}
    />
  </div>
))
Table.displayName = "Table"

const TableHeader = React.forwardRef((props, ref) => (
  <thead
    ref={ref}
    className={cn("[&_tr]:border-b [&_th]:font-bold [&_th]:text-lg ", props.className)}
    {...props}
  />
))
TableHeader.displayName = "TableHeader"

const TableBody = React.forwardRef((props, ref) => (
  <tbody
    ref={ref}
    className={cn("[&_tr:last-child]:border-0", props.className)}
    {...props}
  />
))
TableBody.displayName = "TableBody"

const TableRow = React.forwardRef((props, ref) => (
  <tr
    ref={ref}
    className={cn(
      "border-b transition-colors hover:bg-muted/50",
      props.className
    )}
    {...props}
  />
))
TableRow.displayName = "TableRow"

const TableHead = React.forwardRef((props, ref) => (
  <th
    ref={ref}
    className={cn(
      "h-12 px-4 text-left font-medium text-muted-foreground",
      props.className
    )}
    {...props}
  />
))
TableHead.displayName = "TableHead"

const TableCell = React.forwardRef((props, ref) => (
  <td
    ref={ref}
    className={cn("pr-4 pl-4 pt-2 pb-2 text-nowrap align-middle text-black font-bold", props.className)}
    {...props}
  />
))
TableCell.displayName = "TableCell"

export {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
}
